import axios from "axios";
import "./interceptors";

/**
 * Contest partners (sponsors) shown in the app's Contest tab.
 *
 * These are NOT users and NOT song collaborators — the Song Contest screen's
 * "partners" are a submission's co-authors, a different thing that happens to
 * share the word. A contest partner is an admin-managed sponsor row
 * (`contest_partners`) with a logo and a promo video, surfaced by the app's
 * `GET /contest/partners`.
 *
 * The API has had full CRUD for these since 5.0.8, but nothing in the Admin
 * Site ever called it, so `GET /contest/partners` could only ever return `[]`
 * and the app's "Contest Partners" section was permanently empty. This module
 * plus containers/contest-partners is that missing half.
 */

export function getContestPartners() {
  return (dispatch) => {
    return axios
      .get(`api/v1/admin/contest-partners`)
      .then((res) => res)
      .catch((error) => error && error.response);
  };
}

export function createContestPartner(data) {
  return (dispatch) => {
    return axios
      .post(`api/v1/admin/contest-partners`, data)
      .then((res) => res)
      .catch((error) => error && error.response);
  };
}

export function updateContestPartner(id, data) {
  return (dispatch) => {
    return axios
      .put(`api/v1/admin/contest-partners/${id}`, data)
      .then((res) => res)
      .catch((error) => error && error.response);
  };
}

export function deleteContestPartner(id) {
  return (dispatch) => {
    return axios
      .delete(`api/v1/admin/contest-partners/${id}`)
      .then((res) => res)
      .catch((error) => error && error.response);
  };
}
